import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useLanguage } from './i18n/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LegalHub from './pages/LegalHub';
import LegalDoc from './pages/LegalDoc';

function App() {
  const location = useLocation();
  const { t } = useLanguage();
  const urlParams = new URLSearchParams(location.search);
  const isWebview = urlParams.get('webview') === 'true';

  useEffect(() => {
    document.body.classList.toggle('webview-light', isWebview);
    return () => document.body.classList.remove('webview-light');
  }, [isWebview]);

  return (
    <>
      <Helmet>
        <title>{t.meta.title}</title>
        <meta name="description" content={t.meta.description} />
      </Helmet>

      {!isWebview && <Header />}

      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/legal" element={<LegalHub />} />
          <Route path="/legal/:project/:doc" element={<LegalDoc isWebview={isWebview} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      {!isWebview && <Footer />}
    </>
  );
}

export default App;
